/** @format */

import React, { useEffect } from 'react';
import { Grid, FormControlLabel, Typography, Checkbox } from '@mui/material';
import { useStyles } from './style';
import { useFormContext } from 'react-hook-form';
import {
  InputV2,
  SelectV,
  GuildsSelect,
  BusinessesSelect,
  ProductsSelect,
  Icons,
} from 'components';
import { Controller } from 'react-hook-form';
import { USE_PERIODS } from '../../index';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';

const Constraints = ({
  startDate,
  handleChangeStart,
  isGroup,
  expireDate,
  handleChangeExpire,
  usageEnabled,
  setUsageEnabled,
  guilds,
  setGuilds,
  usages,
  setUsages,
  selectedProducts,
  setSelectedProducts,
  usageLimitsEnabled,
  setUsageLimitsEnabled,
  usagePeriodEnabled,
  setUsagePeriodEnabled,
  periodicEnabled,
  setPeriodicEnabled,
}) => {
  // -- HOOKS --//
  const methods = useFormContext();
  const classes = useStyles();
  const { control, register, formState: { errors }, setValue } = methods;

  useEffect(() => {
    methods.register('usePeriod');
    methods.register('usePeriodCount');
    return () => {
      methods.unregister('usePeriod');
      methods.unregister('usePeriodCount');
    };
  }, [methods.register, methods.unregister]);

  // -- API REQUESTS --//

  return (
    <Grid container direction="row" alignItems="center" item xs={12}>
      <Grid container style={{ marginTop: 8 }} spacing={1}>
        <Grid item xs={12} md={6}>
          <InputV2
            multiline
            fullWidth
            errors={errors}
            label="شرح انتقال"
            rules={['isNotContainTag']}
            name="description"
            register={register}
            control={control}
          />
        </Grid>
      </Grid>

      {!isGroup ? (
        <Grid item xs={12} md={2}>
          <InputV2
            fullWidth
            errors={errors}
            rules={['isNotContainTag']}
            name="uniqueId"
            register={register}
            label="شناسه یکتا"
            control={control}
            englishNumber
          />
        </Grid>
      ) : null}

      <Grid container style={{ marginTop: 8 }}>
        <Controller
          name="usageEnabled"
          control={control}
          render={({ field: { onChange, value, ...rest } }) => (
            <FormControlLabel
              value={value}
              control={
                <Checkbox
                  style={{ color: '#448aff' }}
                  {...rest}
                  onChange={(e) => {
                    setUsageEnabled(e.target.checked);
                    onChange(e.target.checked);
                  }}
                  checked={value}
                  value={value}
                  icon={<CheckBoxIcon />}
                  checkedIcon={<CheckBoxIconFill />}
                />
              }
              label="اعمال محدودیت بر روی محل مصرف"
            />
          )}
          defaultValue={null}
        />
      </Grid>

      {usageEnabled ? (
        <>
          <Grid container style={{ marginTop: 8 }}>
            <Grid item xs={12} md={6}>
              <GuildsSelect
                methods={methods}
                name="guildUsage"
                label="محدودیت در حساب‌های تفصیلی (اصناف) کسب‌وکار"
                selected={guilds}
                setSelected={setGuilds}
                showBusinessGuilds={false}
              />
            </Grid>
          </Grid>

          <Grid container style={{ marginTop: 8 }}>
            <Grid item xs={12} md={6}>
              <BusinessesSelect
                name="bizUsage"
                label="محدودیت در کسب‌وکار"
                methods={methods}
                selected={usages}
                setSelected={setUsages}
              />
            </Grid>
          </Grid>

          <Grid container style={{ marginTop: 8 }}>
            <Grid item xs={12} md={6}>
              <ProductsSelect
                methods={methods}
                name="serviceUsage"
                label="محدودیت استفاده روی محصولات یا سرویس‌ها"
                tooltip="کاربر تنها برای خرید این محصول(محصولات) می‌تواند از اعتبار خرج کند."
                selected={selectedProducts}
                setSelected={setSelectedProducts}
              />
            </Grid>
          </Grid>
        </>
      ) : null}

      <Grid container style={{ marginTop: 16 }}>
        <Controller
          name="usageLimitsEnabled"
          control={control}
          render={({ field: { onChange, value, ...rest } }) => (
            <FormControlLabel
              value={value}
              control={
                <Checkbox
                  style={{ color: '#448aff' }}
                  {...rest}
                  onChange={(e) => {
                    setUsageLimitsEnabled(e.target.checked);
                    onChange(e.target.checked);
                    setValue('usePeriod', null);
                    setValue('usePeriodCount', null);
                    setUsagePeriodEnabled(false);
                  }}
                  checked={value}
                  value={value}
                  icon={<CheckBoxIcon />}
                  checkedIcon={<CheckBoxIconFill />}
                />
              }
              label="اعمال محدودیت میزان مصرف در بازه زمانی"
            />
          )}
          defaultValue={null}
        />
      </Grid>

      {usageLimitsEnabled ? (
        <>
          <Grid item xs={12} md={2}>
            <InputV2
              fullWidth
              errors={errors}
              rules={['isNumeric', 'isMin|1' , 'isNotContainTag']}
              label="حداکثر دفعات مصرف"
              name="maxTryCount"
              register={register}
              control={control}
              englishNumber
              currency
              currencyText="مرتبه"
            />
          </Grid>

          <Grid container style={{ marginTop: 16 }}>
            <Controller
              name="usagePeriodEnabled"
              control={control}
              render={({ field: { onChange, value, ...rest } }) => (
                <FormControlLabel
                  value={value}
                  control={
                    <Checkbox
                      style={{ color: '#448aff' }}
                      {...rest}
                      onChange={(e) => {
                        setUsagePeriodEnabled(e.target.checked);
                        onChange(e.target.checked);
                        if (!e.target.checked) {
                          setValue('usePeriod', null);
                          setValue('usePeriodCount', null);
                        }
                      }}
                      checked={value}
                      value={value}
                      icon={<CheckBoxIcon />}
                      checkedIcon={<CheckBoxIconFill />}
                    />
                  }
                  label="اعمال بازه زمانی مصرف"
                />
              )}
              defaultValue={null}
            />
          </Grid>
          {/*  */}
          {usagePeriodEnabled ? (
            <Grid container spacing={1}>
              <Grid item xs={12} md={2}>
                <InputV2
                  fullWidth
                  errors={errors}
                  rules={['isNumeric', 'isMin|1' , 'isNotContainTag']}
                  decimalPlaces={0}
                  minimumValue={1}
                  name="usePeriodCount"
                  register={register}
                  label="تعداد دوره"
                  control={control}
                  englishNumber
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <SelectV
                  label="نوع بازه زمانی"
                  name="usePeriod"
                  options={USE_PERIODS}
                  defaultValue=""
                  control={control}
                  register={register}
                  errors={errors}
                  fullWidth
                />
              </Grid>
            </Grid>
          ) : null}
        </>
      ) : null}

      <Grid container style={{ marginTop: 16 }}>
        <Controller
          name="periodicEnabled"
          control={control}
          render={({ field: { onChange, value, ...rest } }) => (
            <FormControlLabel
              value={value}
              control={
                <Checkbox
                  style={{ color: '#448aff' }}
                  {...rest}
                  onChange={(e) => {
                    setPeriodicEnabled(e.target.checked);
                    onChange(e.target.checked);
                  }}
                  checked={value}
                  value={value}
                  icon={<CheckBoxIcon />}
                  checkedIcon={<CheckBoxIconFill />}
                />
              }
              label="اعمال تمدید خودکار دوره‌ای"
            />
          )}
          defaultValue={null}
        />
      </Grid>

      {periodicEnabled ? (
        <>
          <Grid container style={{ marginTop: 30 }}>
            <Grid item xs={12} md={6}>
              <Grid
                className={classes.dangerBox}
                container
                direction="row"
                alignItems="flex-start"
                justifyContent="flex-start"
              >
                <Grid item>
                  <Icons icon="WarningTriangle" color="#E03E1A" size="28" />
                </Grid>
                <Grid item xs>
                  <Typography className={classes.dangerText}>
                    توجه کنید که این بخش بسیار حساس بوده و اگر فعال شود و به هر دلیل فراموش کنید
                    تمدید را غیرفعال نمایید هیچ اخطاری صادر نخواهد شد. بنابراین این بخش باید توسط
                    اعتبار دهنده به صورت متناوب چک و در صورت نیاز غیرفعال شود.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container style={{ marginTop: 8 }} spacing={1}>
            <Grid item xs={12} md={3}>
              <InputV2
                fullWidth
                errors={errors}
                rules={['isNumeric' , 'isNotContainTag']}
                label="دوره تکرار"
                name="periodCount"
                register={register}
                control={control}
                englishNumber
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <SelectV
                label="بازه زمانی"
                name="periodCode"
                options={[
                  { value: 'DAY_PERIOD', label: 'روز' },
                  { value: 'MONTH_PERIOD', label: 'ماه' },
                  { value: 'YEAR_PERIOD', label: 'سال' },
                ]}
                control={control}
                errors={errors}
                fullWidth
              />
            </Grid>
          </Grid>
        </>
      ) : null}
    </Grid>
  );
};

export default Constraints;
